/* src/app/global/components/global-update-dialog/global-update-dialog.component.scss */
.mat-mdc-dialog-title {
  margin: 0;
  font-size: 10pt;
}
.mat-mdc-dialog-actions {
  justify-content: center;
  margin: 5pt;
}
/*# sourceMappingURL=global-update-dialog.component.css.map */
